import InnerLayout from "@/views/inner-layout";

export default [
  {
    path: "/travel",
    component: InnerLayout,
    redirect: "/travel",
    meta: {
      title: "旅游出行", // 旅游出行
    },
    children: [
      {
        path: "sales-qualification",
        component: () => import("@/views/travel/sales-qualification.vue"),
        name: "SalesQualification",
        meta: { title: "资格售卖" }, //资格售卖
      },
      {
        path: "qualification-inquiry",
        component: () => import("@/views/travel/qualification-inquiry.vue"),
        name: "QualificationInquiry",
        meta: { title: "资格查询" }, //资格查询
      },
      {
        path: "enter-information",
        component: () => import("@/views/travel/qualification-inquiry.vue"),
        name: "EnterInformation",
        meta: { title: "信息录入" }, //信息录入
      },
    ],
  },
];
